<template>
  <div>
    {{$t('customer_select.filter')}}
    <v-text-field
      solo
      clearable
      v-model="filter"
      :label="$t('customer_select.filter')"
      @input="isChangingFilter = true"
    ></v-text-field>
    {{ $t('customer_select.choose_customer')}}
    <v-select
      id="customerSelect"
      ref="customerSelect"
      centre
      required
      solo
      v-model="customer"
      :items="customers"
      :label="$t('customer_select.customer')"
      :no-data-text="emptyText"
      :loading="loading"
      @change="selectedCustomer"
    ></v-select>
    <!-- Contact select -->
    <div v-if="customerSelected">
      {{$t('customer_select.choose_contact')}}
      <v-select
        id="contactSelect"
        ref="contactSelect"
        centre
        required
        solo
        v-model="contact"
        :items="contacts"
        :label="$t('customer_select.contact')"
        :no-data-text="$t('customer_select.no_contacts')"
        @change="selectedContact"
      ></v-select>
      {{$t('customer_select.choose_address')}}
      <v-select
        id="addressSelect"
        ref="contactSelect"
        centre
        required
        solo
        v-model="address"
        :items="addresses"
        :label="$t('customer_select.address')"
        :no-data-text="$t('customer_select.no_addresses')"
        @change="selectedAddress"
      ></v-select>
    </div>
  </div>
</template>

<script>
import Customer from "@/models/Customer.js";
export default {
  props: ["user"],
  data() {
    return {
      customer: null,
      customers: [],
      contact: null,
      contacts: [],
      address: null,
      addresses: [],
      filter: "",
      loading: false,
      isChangingFilter: false,
      filterTimer: 0,
      customerObj: new Customer(this.$session.get("jwt"))
    };
  },

  computed: {
    emptyText() {
      if (this.filter == null || this.filter == "") {
        return this.$t("customer_select.enter_filter");
      }
      return this.$t("customer_select.no_customers_found");
    },
    customerSelected() {
      return this.contacts.length > 0 || this.addresses.length > 0;
    }
  },

  watch: {
    isChangingFilter(val) {
      if (!val) {
        this.getCustomers();
      }
    },
    filter(){
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {
        this.isChangingFilter = false;
      }, 500);
    }
  },

  methods: {
    selectedContact() {
      this.$emit("contactSelected", this.contact);
    },

    selectedAddress(){
      this.$emit('addressSelected', this.address);
    },

    selectedCustomer() {
      this.customerObj.loadCustomer(this.customer).then(response => {
        this.contacts = this.prepareContactsForSelect(response.data.contacts);
        this.addresses = this.prepareAddressesForSelect(response.data.addresses);
        this.$emit("customerSelected", this.customer);
      });
    },

    getCustomers() {
      this.loading = true;
      this.customerObj
        .loadCustomers({
          params: {
            filter: this.filter,
            rows: 10
          }
        })
        .then(response => {
          let customers = response.data.data;
          this.customers = this.prepareCustomersForSelect(customers);
          this.loading = false;
          this.dropDown();
        });
    },

    prepareContactsForSelect(contacts) {
      let contactsSelection = [];
      contacts.forEach(contact => {
        const name =
          contact.name != null && contact.name != "" ? contact.name : "";
        const mobile =
          contact.mobile != null && contact.mobile != "" ? contact.mobile : "";
        const email =
          contact.email != null && contact.email != "" ? contact.email : "";
        contactsSelection.push({
          text: name + " " + mobile + " " + email, // + nr t.t.
          value: contact.id
        });
      });
      return contactsSelection;
    },

    prepareAddressesForSelect(addresses){
      let addressesSelection = [];
      addresses.forEach(address => {
        const street = address.street ? address.street : "";
        const city = address.city ? address.city : "";
        addressesSelection.push({
          text: street + ", " + city,
          value: address.id
        });
      });
      return addressesSelection;
    },

    prepareCustomersForSelect(customers) {
      let customerSelection = [];
      customers.forEach(customer => {
        customerSelection.push({
          text: customer["name"],
          value: customer["id"]
        });
      });
      return customerSelection;
    },

    clearValues() {
      this.customers = [];
      this.customer = null;
      this.contact = null;
      this.contacts = [];
      this.address = null;
      this.addresses = [];
      this.filter = "";
    },

    dropDown() {
      document.getElementById("customerSelect").click(); // Click on the checkbox
    }
  }
};
</script>
